interface BaseErrorOptions {
  statusCode: number | string;
  message: string;
  info?: any;
  cause?: Error | OfficeExtension.Error;
}

export default class BaseError extends Error {
  public statusCode: number | string;
  public info?: any;
  public cause?: Error | OfficeExtension.Error;

  constructor(options: BaseErrorOptions) {
    super(options.message, { cause: options.cause });
    this.statusCode = options.statusCode;
    this.info = options?.info;
    this.cause = options?.cause;

    Object.setPrototypeOf(this, new.target.prototype); // Restore prototype chain

    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, this.constructor);
    }
  }
}
